import { ExternalBalanceProviderEnum, LiquidatorName } from '../enums';
export const LiquidatorProviders = {
    [LiquidatorName.BTSE]: ExternalBalanceProviderEnum.BTSE,
    [LiquidatorName.BYBIT]: ExternalBalanceProviderEnum.BYBIT,
    [LiquidatorName.BITGET]: ExternalBalanceProviderEnum.BITGET,
    [LiquidatorName.KRAKEN]: ExternalBalanceProviderEnum.KRAKEN,
    [LiquidatorName.WHITEBIT]: ExternalBalanceProviderEnum.WHITEBIT,
};
export const ProviderLiquidator = {
    [ExternalBalanceProviderEnum.BTSE]: LiquidatorName.BTSE,
    [ExternalBalanceProviderEnum.BTSE_INTERNAL]: LiquidatorName.BTSE,
    [ExternalBalanceProviderEnum.BYBIT]: LiquidatorName.BYBIT,
    [ExternalBalanceProviderEnum.BYBIT_INTERNAL]: LiquidatorName.BYBIT,
    [ExternalBalanceProviderEnum.BITGET]: LiquidatorName.BITGET,
    [ExternalBalanceProviderEnum.BITGET_INTERNAL]: LiquidatorName.BITGET,
    [ExternalBalanceProviderEnum.KRAKEN]: LiquidatorName.KRAKEN,
    [ExternalBalanceProviderEnum.WHITEBIT]: LiquidatorName.WHITEBIT,
    [ExternalBalanceProviderEnum.WHITEBIT_INTERNAL]: LiquidatorName.WHITEBIT,
    [ExternalBalanceProviderEnum.FIREBLOCKS]: undefined,
};
export const LiquidatorInternalProviders = {
    [LiquidatorName.BTSE]: ExternalBalanceProviderEnum.BTSE_INTERNAL,
    [LiquidatorName.BYBIT]: ExternalBalanceProviderEnum.BYBIT_INTERNAL,
    [LiquidatorName.BITGET]: ExternalBalanceProviderEnum.BITGET_INTERNAL,
    [LiquidatorName.WHITEBIT]: ExternalBalanceProviderEnum.WHITEBIT_INTERNAL,
    [LiquidatorName.KRAKEN]: undefined,
};
//# sourceMappingURL=liquidator-providers.js.map